import {
  genericGetSingle,
  genericGetAll,
  genericUpdateSingle,
} from "../helpers/apiCall";
import { OrderLine } from "../models";

/**
 * Get all order lines
 * @param params URLSearchParams
 * @returns Promise<{ order_lines: OrderLine[] }>
 */
function getAll(
  params: URLSearchParams = null,
): Promise<{ order_lines: OrderLine[] }> {
  return genericGetAll("order_lines", params);
}

/**
 * Get a single order line
 * @param id string
 * @returns Promise<{ order_line: OrderLine }>
 */
function getSingle(id: string): Promise<{ order_line: OrderLine }> {
  return genericGetSingle("order_lines", id);
}

/**
 * Gets the count of order lines
 * @param params URLSearchParams
 * @returns Promise<{ count: number }>
 */
function getCount(params: URLSearchParams = null): Promise<{ count: number }> {
  if (!params) params = new URLSearchParams();
  params.append("countOnly", "true");
  return genericGetAll("order_lines", params);
}

/**
 * Updates a single order line record in the "order_lines" table.
 *
 * @param id The unique identifier of the order line to update.
 * @param order_line An object containing the fields and values to update for the order line.
 * @returns A Promise resolving to an object with the updated order_line.
 */
function updateSingle(
  id: string,
  order_line: { [key: string]: string | number | boolean | Date | undefined },
): Promise<{ order_line: OrderLine }> {
  return genericUpdateSingle("order_lines", id, order_line);
}

export const orderLineService = {
  getAll,
  getSingle,
  getCount,
  updateSingle,
};
